import type { I18nShape } from '@tribeplatform/react-components/i18n'

type KnownRoleNames = 'Admin' | 'Moderator' | 'Member' | 'Unverified'

export const getTranslatedRoleName = ({ $t }: I18nShape, roleName: string) => {
  const knownRoleName = roleName as KnownRoleNames
  switch (knownRoleName) {
    case 'Admin':
      return $t({
        defaultMessage: 'Admin',
        id: 'Roles.Admin',
      })
    case 'Moderator':
      return $t({
        defaultMessage: 'Moderator',
        id: 'Roles.Moderator',
      })
    case 'Member':
      return $t({
        defaultMessage: 'Member',
        id: 'Roles.Member',
      })
    case 'Unverified':
      return $t({
        defaultMessage: 'Unverified',
        id: 'Roles.Unverified',
      })
    default: {
      // Performing an exhaustive check, hence discarding the variable
      // eslint-disable-next-line unused-imports/no-unused-vars
      const exhaustiveCheck: never = knownRoleName

      return knownRoleName
    }
  }
}
